<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2"> 
    <div class="form-horizontal">
     <div class="row">
       <div class="col-md-12">
         <div class="form-group row">
             <div class="col-md-12">
               <yt-input
                 [Type]="'text'"
                 name="txtNaziv"
                 formControlName="Naziv"
                 #focusElement
                 [MaxLength]="50"
                 [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                 [Label]="'NACINPLACANJA.NAZIV.SINGULAR'"
                 >
               </yt-input>
                 <!-- <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                     <span *ngFor="let validation of errorMessages.Naziv">
                       <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                     </span>                       
                   </div> -->
             </div>
           </div>
         </div>
     </div>
   </div>
 </form>